<div class="page-content">
  <!-- HEADER -->
  <div class="page_header">
    <div class="page_header_text">
      <app-back-button></app-back-button>
    </div>
    <div class="page_header_actions" *ngIf="equipamento">
      <button class="btn-secondary" (click)="editarEquipamento()">
        <i class="ri-pencil-line"></i> Editar
      </button>
    </div>
  </div>

  <!-- SKELETON -->
  <ng-container *ngIf="loading">
    <p-skeleton height="220px" styleClass="mb-4" borderRadius="16px"></p-skeleton>
    <p-skeleton height="48px" styleClass="mb-3" borderRadius="10px"></p-skeleton>
    <p-skeleton height="260px" borderRadius="12px"></p-skeleton>
  </ng-container>

  <ng-container *ngIf="!loading && equipamento">
    <!-- HERO -->
    <div class="eq-hero">
      <div class="eq-hero-top">
        <!-- Foto / Placeholder -->
        <div class="eq-photo" [ngClass]="getEstadoClass(equipamento.estado) || 'badge-default'">
          <app-equipment-photo [src]="equipamento.fotoUrl" alt="Foto do equipamento"
            [fallbackIcon]="equipamento.tipoEquipamento?.icon || 'pi pi-box'" fallbackLabel="Sem foto" />
        </div>

        <!-- Info principal -->
        <div class="eq-hero-info">
          <h2 class="eq-hero-name" *ngIf="isViatura || isArma">{{ viaturaTitulo }}</h2>
          <h2 class="eq-hero-name" *ngIf="!isViatura && !isArma">{{ nomeItemUtensilio || equipamentoDisplayName }}</h2>

          <div class="eq-hero-subtitle" *ngIf="isViatura && matriculaEquipamento as matricula">
            <span>
              <i class="ri-car-line"></i> {{ matricula }}
            </span>
            <span *ngIf="uaCCustosEquipamento as uaCCustos">
              <i class="ri-money-dollar-circle-line"></i> {{ uaCCustos }}
            </span>
          </div>
          <div class="eq-hero-subtitle" *ngIf="!isViatura && numeroSerieEquipamento as ns">
            <i class="ri-barcode-line"></i> {{ ns }}
          </div>

          <div class="eq-hero-badges">
            <span class="type-badge" *ngIf="equipamento.tipoEquipamento?.designacao">
              <i [class]="equipamento.tipoEquipamento!.icon || 'pi pi-box'"></i>
              {{ equipamento.tipoEquipamento!.designacao.trim() }}
            </span>
            <span class="estado-badge" [ngClass]="getEstadoClass(equipamento.estado)" *ngIf="equipamento.estado">
              <i class="ri-radio-button-line"></i>
              {{ getEstadoLabel(equipamento.estado) }}
            </span>
            <span class="estado-viatura-badge" [ngClass]="getEstadoViaturaClass(estadoViaturaDireto)" *ngIf="estadoViaturaDireto">
              <i class="ri-speed-line"></i> {{ estadoViaturaDireto }}
            </span>
            <span class="inativo-badge" *ngIf="equipamento.ativo === false">
              <i class="ri-eye-off-line"></i> Inactivo
            </span>
            <span class="combustivel-badge" *ngIf="tipoCombustivelEquipamento as combustivel">
              <i class="ri-gas-station-line"></i> {{ combustivel }}
            </span>
            <span class="seguro-badge" [ngClass]="'seguro-' + seguroSituacao.tone" *ngIf="seguroSituacao as seg">
              <i class="ri-shield-check-line"></i> {{ seg.label }}
            </span>
            <span class="no-data-badge" *ngIf="
                !equipamento.tipoEquipamento?.designacao &&
                !equipamento.estado &&
                !estadoViaturaDireto &&
                !tipoCombustivelEquipamento &&
                !seguroSituacao &&
                equipamento.ativo !== false
              ">
              <i class="ri-question-line"></i> Sem classificação
            </span>
          </div>

          <div class="eq-hero-specs">
            <div class="eq-spec-item" *ngIf="postoAtribuidoNome || equipamento.posto?.nome">
              <i class="ri-map-pin-2-line"></i>
              <span>{{ postoAtribuidoNome || equipamento.posto?.nome }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- KPI strip -->
      <div class="eq-hero-kpis">
        <div class="eq-kpi">
          <span class="eq-kpi-val">{{
            formatDate(equipamento.dataAquisicao)
            }}</span>
          <span class="eq-kpi-lbl"><i class="ri-calendar-line"></i> Data de Aquisição</span>
        </div>
        <div class="eq-kpi">
          <span class="eq-kpi-val green">{{
            formatKz(equipamento.valorAquisicao)
            }}</span>
          <span class="eq-kpi-lbl"><i class="ri-money-dollar-circle-line"></i> Valor de
            Aquisição</span>
        </div>
        <div class="eq-kpi">
          <span class="eq-kpi-val">{{ isArma ? inspecaoCount : maintenanceCount }}</span>
          <span class="eq-kpi-lbl">
            <i [class]="isArma ? 'ri-shield-check-line' : 'ri-tools-line'"></i>
            {{ isArma ? 'Inspeções' : 'Manutenções' }}
          </span>
        </div>
        <div class="eq-kpi">
          <span class="eq-kpi-val">{{ documentos.length }}</span>
          <span class="eq-kpi-lbl"><i class="ri-folder-2-line"></i> Documentos</span>
        </div>
      </div>
    </div>

    <!-- TABS -->
    <p-tabs [(value)]="activeTab">
      <p-tablist>
        <p-tab value="0"><i class="ri-information-line"></i> Geral</p-tab>
        <p-tab value="1">
          <i [class]="isArma ? 'ri-shield-check-line' : 'ri-tools-line'"></i>
          {{ isArma ? 'Inspeção' : 'Manutenções' }}
          <span class="tab-badge">{{ isArma ? inspecaoCount : maintenanceCount }}</span>
        </p-tab>
        <p-tab value="2" *ngIf="isViatura">
          <i class="ri-shield-check-line"></i> Seguro
        </p-tab>
        <p-tab value="3" *ngIf="isViatura">
          <i class="ri-gas-station-line"></i> Combustível
        </p-tab>
        <p-tab value="4">
          <i class="ri-folder-2-line"></i> Documentação
          <span class="tab-badge">{{ documentos.length }}</span>
        </p-tab>
      </p-tablist>

      <!-- ── Tab 0: Geral ───────────────────────────────────────────────────── -->
      <p-tabpanel value="0">
        <!-- ═══ ARMA: 3 cards específicos ═══ -->
        <ng-container *ngIf="isArma">
          <div class="tab-grid">
            <!-- Card 1: Resumo Operacional -->
            <div class="info-card">
              <div class="ic-header">
                <i class="ri-speed-line"></i> Resumo Operacional
              </div>
              <div class="ic-body">
                <div class="ic-row">
                  <span class="ic-key">Estado atual</span>
                  <span class="ic-val">
                    <span class="badge-inline" [ngClass]="getEstadoClass(equipamento.estado)">
                      {{ getEstadoLabel(equipamento.estado) }}
                    </span>
                  </span>
                </div>
                <div class="ic-row" *ngIf="equipamento.ativo !== undefined">
                  <span class="ic-key">Disponibilidade</span>
                  <span class="ic-val">
                    <span class="badge-inline" [ngClass]="equipamento.ativo ? 'badge-bom' : 'badge-inativo'">
                      {{ equipamento.ativo ? "Activo" : "Inactivo" }}
                    </span>
                  </span>
                </div>
                <div class="ic-row" *ngIf="postoAtribuidoNome || equipamento.posto?.nome">
                  <span class="ic-key">Posto Atribuído</span>
                  <span class="ic-val">{{ postoAtribuidoNome || equipamento.posto?.nome }}</span>
                </div>
                <div class="ic-row" *ngIf="guardaResponsavelArma as guarda">
                  <span class="ic-key">Guarda Responsável</span>
                  <span class="ic-val">{{ guarda }}</span>
                </div>
                <div class="ic-row">
                  <span class="ic-key">Situação da Licença</span>
                  <span class="ic-val">
                    <ng-container *ngIf="situacaoLicencaArma as situacao; else semLicenca">
                      <span class="badge-inline" [ngClass]="situacao.tone === 'ok' ? 'badge-bom' : 'badge-destruido'">
                        {{ situacao.label }}
                      </span>
                    </ng-container>
                    <ng-template #semLicenca>
                      <span class="badge-inline">—</span>
                    </ng-template>
                  </span>
                </div>
                <div class="ic-row">
                  <span class="ic-key">Próxima verificação</span>
                  <span class="ic-val">{{ proximaVerificacaoArma ? formatDate(proximaVerificacaoArma) : "—" }}</span>
                </div>
              </div>
            </div>

            <!-- Card 2: Dados da Arma -->
            <div class="info-card">
              <div class="ic-header">
                <i class="ri-shield-line"></i> Dados da Arma
              </div>
              <div class="ic-body">
                <div class="ic-row" *ngIf="tipoArma as tipo">
                  <span class="ic-key">Tipo</span>
                  <span class="ic-val">{{ tipo }}</span>
                </div>
                <div class="ic-row" *ngIf="marcaArma as marca">
                  <span class="ic-key">Marca</span>
                  <span class="ic-val">{{ marca }}</span>
                </div>
                <div class="ic-row" *ngIf="modeloArma as modelo">
                  <span class="ic-key">Modelo</span>
                  <span class="ic-val">{{ modelo }}</span>
                </div>
                <div class="ic-row" *ngIf="calibreArma as calibre">
                  <span class="ic-key">Calibre</span>
                  <span class="ic-val">{{ calibre }}</span>
                </div>
                <div class="ic-row" *ngIf="corEquipamento as cor">
                  <span class="ic-key">Cor de Acabamento</span>
                  <span class="ic-val">{{ cor }}</span>
                </div>
                <div class="ic-row" *ngIf="paisOrigemArma as pais">
                  <span class="ic-key">País de Origem</span>
                  <span class="ic-val">{{ pais }}</span>
                </div>
                <div class="ic-row" *ngIf="capacidadeMunicoesArma as cap">
                  <span class="ic-key">Capacidade de Munições</span>
                  <span class="ic-val">{{ cap }}</span>
                </div>
                <div class="ic-row" *ngIf="anoFabricoEquipamento as ano">
                  <span class="ic-key">Ano de Fabrico</span>
                  <span class="ic-val">{{ ano }}</span>
                </div>
              </div>
            </div>

            <!-- Card 3: Dados Administrativos -->
            <div class="info-card admin-card">
              <div class="ic-header">
                <i class="ri-file-list-3-line"></i> Dados Administrativos
              </div>
              <div class="ic-body">
                <div class="ic-row" *ngIf="numeroSerieEquipamento as ns">
                  <span class="ic-key">Nº de Série / Matrícula</span>
                  <span class="ic-val mono">{{ ns }}</span>
                </div>
                <div class="ic-row">
                  <span class="ic-key">Data de Aquisição</span>
                  <span class="ic-val">{{ formatDate(equipamento.dataAquisicao) }}</span>
                </div>
                <div class="ic-row">
                  <span class="ic-key">Valor de Aquisição</span>
                  <span class="ic-val">{{ formatKz(equipamento.valorAquisicao) }}</span>
                </div>
                <div class="ic-row" *ngIf="equipamento.quantidade != null">
                  <span class="ic-key">Quantidade</span>
                  <span class="ic-val">{{ equipamento.quantidade }}</span>
                </div>
                <div class="ic-row" *ngIf="numeroLicencaArma as nl">
                  <span class="ic-key">Número da Licença</span>
                  <span class="ic-val mono">{{ nl }}</span>
                </div>
                <div class="ic-row" *ngIf="entidadeEmissoraArma as ent">
                  <span class="ic-key">Entidade Emissora</span>
                  <span class="ic-val">{{ ent }}</span>
                </div>
                <div class="ic-row" *ngIf="dataEmissaoLicencaArma as de">
                  <span class="ic-key">Data de Emissão da Licença</span>
                  <span class="ic-val">{{ formatDate(de) }}</span>
                </div>
                <div class="ic-row" *ngIf="validadeLicencaArma as vl">
                  <span class="ic-key">Validade da Licença</span>
                  <span class="ic-val">{{ formatDate(vl) }}</span>
                </div>
                <div class="ic-row" *ngIf="dataUltimaVerificacaoArma as dv">
                  <span class="ic-key">Data da Última Verificação</span>
                  <span class="ic-val">{{ formatDate(dv) }}</span>
                </div>
                <div class="ic-row" *ngIf="frequenciaVerificacaoArma as fv">
                  <span class="ic-key">Frequência de Verificação</span>
                  <span class="ic-val">{{ fv }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="info-card obs-card" *ngIf="equipamento.observacoes" style="margin-top: 16px;">
            <div class="ic-header">
              <i class="ri-sticky-note-line"></i> Observações
            </div>
            <div class="ic-body">
              <p class="obs-text">{{ equipamento.observacoes }}</p>
            </div>
          </div>
        </ng-container>

        <!-- ═══ UTENSÍLIO / GENÉRICO: 3 cards específicos ═══ -->
        <ng-container *ngIf="!isViatura && !isArma">
          <div class="tab-grid">
            <!-- Card 1: Resumo Operacional -->
            <div class="info-card">
              <div class="ic-header">
                <i class="ri-speed-line"></i> Resumo Operacional
              </div>
              <div class="ic-body">
                <div class="ic-row">
                  <span class="ic-key">Estado</span>
                  <span class="ic-val">
                    <span class="badge-inline" [ngClass]="getEstadoClass(equipamento.estado)">
                      {{ getEstadoLabel(equipamento.estado) }}
                    </span>
                  </span>
                </div>
                <div class="ic-row" *ngIf="equipamento.ativo !== undefined">
                  <span class="ic-key">Disponibilidade</span>
                  <span class="ic-val">
                    <span class="badge-inline" [ngClass]="equipamento.ativo ? 'badge-bom' : 'badge-inativo'">
                      {{ equipamento.ativo ? "Activo" : "Inactivo" }}
                    </span>
                  </span>
                </div>
                <div class="ic-row">
                  <span class="ic-key">Posto Atribuído</span>
                  <span class="ic-val">{{ postoAtribuidoNome || equipamento.posto?.nome || "—" }}</span>
                </div>
                <div class="ic-row" *ngIf="responsavelUtensilio as resp">
                  <span class="ic-key">Responsável</span>
                  <span class="ic-val">{{ resp }}</span>
                </div>
              </div>
            </div>

            <!-- Card 2: Dados do Utensílio -->
            <div class="info-card">
              <div class="ic-header">
                <i class="ri-settings-3-line"></i> Dados do Utensílio
              </div>
              <div class="ic-body">
                <div class="ic-row" *ngIf="nomeItemUtensilio as nome">
                  <span class="ic-key">Nome Item</span>
                  <span class="ic-val">{{ nome }}</span>
                </div>
                <div class="ic-row" *ngIf="categoriaUtensilio as cat">
                  <span class="ic-key">Categoria</span>
                  <span class="ic-val">{{ cat }}</span>
                </div>
                <div class="ic-row">
                  <span class="ic-key">Marca</span>
                  <span class="ic-val">{{ marcaEquipamento || "—" }}</span>
                </div>
                <div class="ic-row">
                  <span class="ic-key">Modelo</span>
                  <span class="ic-val">{{ modeloEquipamento || "—" }}</span>
                </div>
                <div class="ic-row">
                  <span class="ic-key">Tipo de Equipamento</span>
                  <span class="ic-val">
                    <span class="tipo-equip-badge">
                      <i [class]="equipamento.tipoEquipamento?.icon || 'pi pi-box'"></i>
                      {{ equipamento.tipoEquipamento?.designacao?.trim() || "—" }}
                    </span>
                  </span>
                </div>
              </div>
            </div>

            <!-- Card 3: Dados Administrativos -->
            <div class="info-card admin-card">
              <div class="ic-header">
                <i class="ri-file-list-3-line"></i> Dados Administrativos
              </div>
              <div class="ic-body">
                <div class="ic-row" *ngIf="numeroSerieEquipamento as ns">
                  <span class="ic-key">Nº de Série / Matrícula</span>
                  <span class="ic-val mono">{{ ns }}</span>
                </div>
                <div class="ic-row" *ngIf="equipamento.quantidade != null">
                  <span class="ic-key">Quantidade</span>
                  <span class="ic-val">{{ equipamento.quantidade }}</span>
                </div>
                <div class="ic-row">
                  <span class="ic-key">Data de Aquisição</span>
                  <span class="ic-val">{{ formatDate(equipamento.dataAquisicao) }}</span>
                </div>
                <div class="ic-row">
                  <span class="ic-key">Valor de Aquisição</span>
                  <span class="ic-val">{{ formatKz(equipamento.valorAquisicao) }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="info-card obs-card" *ngIf="equipamento.observacoes" style="margin-top: 16px;">
            <div class="ic-header">
              <i class="ri-sticky-note-line"></i> Observações
            </div>
            <div class="ic-body">
              <p class="obs-text">{{ equipamento.observacoes }}</p>
            </div>
          </div>
        </ng-container>

        <!-- VIATURA: 3 cards específicos -->
        <div class="tab-grid" *ngIf="isViatura">
          <!-- Card 1: Resumo Operacional -->
          <div class="info-card">
            <div class="ic-header">
              <i class="ri-speed-line"></i> Resumo Operacional
            </div>
            <div class="ic-body">
              <div class="ic-row">
                <span class="ic-key">Estado</span>
                <span class="ic-val">
                  <span class="badge-inline" [ngClass]="getEstadoViaturaClass(estadoViaturaDireto)">
                    {{ estadoViaturaDireto || "—" }}
                  </span>
                </span>
              </div>
              <div class="ic-row">
                <span class="ic-key">Km actual</span>
                <span class="ic-val">{{ kmAtualEquipamento || "—" }}</span>
              </div>
              <div class="ic-row">
                <span class="ic-key">Posto atribuído</span>
                <span class="ic-val">{{ postoAtribuidoNome || equipamento.posto?.nome || "—" }}</span>
              </div>
              <div class="ic-row">
                <span class="ic-key">Motorista</span>
                <span class="ic-val">{{ motoristaEquipamento || "—" }}</span>
              </div>
              <div class="ic-row">
                <span class="ic-key">Estado do GPS</span>
                <span class="ic-val">
                  <ng-container *ngIf="gpsEstadoEquipamento !== null; else gpsSemDados">
                    <span class="badge-inline" [ngClass]="gpsEstadoEquipamento ? 'badge-bom' : 'badge-inativo'">
                      {{ gpsEstadoEquipamento ? "Activo" : "Inactivo" }}
                    </span>
                  </ng-container>
                  <ng-template #gpsSemDados>
                    <span class="badge-inline">—</span>
                  </ng-template>
                </span>
              </div>
              <div class="ic-row">
                <span class="ic-key">Situação do Seguro</span>
                <span class="ic-val">
                  <ng-container *ngIf="seguroSituacao as seg; else seguroSemDados">
                    <span class="badge-inline" [ngClass]="seg.tone === 'ok' ? 'badge-bom' : 'badge-destruido'">
                      {{ seg.label }}
                    </span>
                  </ng-container>
                  <ng-template #seguroSemDados>
                    <span class="badge-inline">—</span>
                  </ng-template>
                </span>
              </div>
              <div class="ic-row">
                <span class="ic-key">Próxima manutenção</span>
                <span class="ic-val">{{ proximaManutencaoData ? formatDate(proximaManutencaoData) : "—" }}</span>
              </div>
              <div class="ic-row" *ngFor="let prop of propriedadesOperacionaisViatura">
                <span class="ic-key">{{ formatPropriedadeLabel(prop.nome) }}</span>
                <span class="ic-val">{{ formatPropriedadeValor(prop) }}</span>
              </div>
            </div>
          </div>

          <!-- Card 2: Dados do Veículo -->
          <div class="info-card">
            <div class="ic-header">
              <i class="ri-car-line"></i> Dados do Veículo
            </div>
            <div class="ic-body">
              <div class="ic-row" *ngIf="marcaNome">
                <span class="ic-key">Marca</span>
                <span class="ic-val">{{ marcaNome }}</span>
              </div>
              <div class="ic-row" *ngIf="modeloNome">
                <span class="ic-key">Modelo</span>
                <span class="ic-val">{{ modeloNome }}</span>
              </div>
              <div class="ic-row" *ngIf="corEquipamento">
                <span class="ic-key">Cor</span>
                <span class="ic-val">{{ corEquipamento }}</span>
              </div>
              <div class="ic-row" *ngIf="anoFabricoEquipamento">
                <span class="ic-key">Ano de Fabrico</span>
                <span class="ic-val">{{ anoFabricoEquipamento }}</span>
              </div>
              <div class="ic-row" *ngIf="chassiEquipamento">
                <span class="ic-key">Nº de Chassi</span>
                <span class="ic-val mono">{{ chassiEquipamento }}</span>
              </div>
              <div class="ic-row" *ngIf="numeroMotorEquipamento">
                <span class="ic-key">Nº de Motor</span>
                <span class="ic-val mono">{{ numeroMotorEquipamento }}</span>
              </div>
              <div class="ic-row" *ngIf="tipoCombustivelEquipamento">
                <span class="ic-key">Tipo de Combustível</span>
                <span class="ic-val">{{ tipoCombustivelEquipamento }}</span>
              </div>
              <div class="ic-row" *ngIf="kmInicialEquipamento">
                <span class="ic-key">Km Inicial</span>
                <span class="ic-val">{{ kmInicialEquipamento }}</span>
              </div>
              <div class="ic-row" *ngFor="let prop of propriedadesVeiculoViatura">
                <span class="ic-key">{{ formatPropriedadeLabel(prop.nome) }}</span>
                <span class="ic-val">{{ formatPropriedadeValor(prop) }}</span>
              </div>
            </div>
          </div>

          <!-- Card 3: Dados Administrativos -->
          <div class="info-card admin-card">
            <div class="ic-header">
              <i class="ri-file-list-3-line"></i> Dados Administrativos
            </div>
            <div class="ic-body">
              <div class="ic-row" *ngIf="matriculaEquipamento">
                <span class="ic-key">Matrícula</span>
                <span class="ic-val mono">{{ matriculaEquipamento }}</span>
              </div>
              <div class="ic-row">
                <span class="ic-key">Data de Aquisição</span>
                <span class="ic-val">{{ formatDate(equipamento.dataAquisicao) }}</span>
              </div>
              <div class="ic-row">
                <span class="ic-key">Valor de Aquisição</span>
                <span class="ic-val">{{ formatKz(equipamento.valorAquisicao) }}</span>
              </div>
              <div class="ic-row" *ngIf="equipamento.codigoInterno">
                <span class="ic-key">Nº de Referência Interna</span>
                <span class="ic-val mono">{{ equipamento.codigoInterno }}</span>
              </div>
              <div class="ic-row" *ngFor="let prop of propriedadesAdministrativasViatura">
                <span class="ic-key">{{ formatPropriedadeLabel(prop.nome) }}</span>
                <span class="ic-val">{{ formatPropriedadeValor(prop) }}</span>
              </div>
            </div>
          </div>
        </div>

      </p-tabpanel>

      <!-- ── Tab 1: Manutenções / Inspeção (Armas) ────────────────────────── -->
      <p-tabpanel value="1">
        <app-equipamento-inspecao-tab *ngIf="equipamento && isArma" [equipamento]="equipamento"
          (countChange)="onInspecaoCountChange($event)" />
        <app-equipamento-maintenance-tab *ngIf="equipamento && !isArma" [equipamentos]="[equipamento]" [equipamentoId]="equipId"
          [tipoLabel]="equipamento.tipoEquipamento?.designacao || 'equipamento'" [openOnInit]="openMaintenanceForm"
          (countChange)="onMaintenanceCountChange($event)" />
      </p-tabpanel>

      <!-- ── Tab 2: Seguro (Viaturas) ──────────────────────────────────────── -->
      <p-tabpanel value="2" *ngIf="isViatura">
        <app-equipamento-seguro-tab *ngIf="equipamento" [equipamento]="equipamento"
          (apoliceChange)="onApoliceChange($event)" />
      </p-tabpanel>

      <!-- ── Tab 3: Combustível (Viaturas) ──────────────────────────────────── -->
      <p-tabpanel value="3" *ngIf="isViatura">
        <app-equipamento-combustivel-tab *ngIf="equipamento" [equipamento]="equipamento"
          (combustivelChange)="onCombustivelChange($event)" />
      </p-tabpanel>

      <!-- ── Tab 4: Documentação ────────────────────────────────────────────── -->
      <p-tabpanel value="4">
        <!-- Action bar -->
        <div class="tab-bar">
          <button class="btn-tab-action" (click)="showNovoDocumento = !showNovoDocumento">
            <i class="ri-add-line"></i> Adicionar Documento
          </button>
        </div>

        <!-- Inline upload panel -->
        <div class="inline-panel" *ngIf="showNovoDocumento">
          <div class="inline-panel-header">
            <span><i class="ri-folder-add-line"></i> Novo Documento</span>
            <button class="btn-icon" (click)="cancelarDocumento()">
              <i class="ri-close-line"></i>
            </button>
          </div>
          <div class="inline-panel-body">
            <div class="upload-area" [class.has-file]="novoDocumento.file" (click)="docUploadInput.click()">
              <input #docUploadInput type="file" hidden (change)="onDocFileSelect($event)" />
              <i class="ri-upload-cloud-2-line" *ngIf="!novoDocumento.file"></i>
              <i class="ri-file-check-line" *ngIf="novoDocumento.file"></i>
              <strong *ngIf="novoDocumento.file">{{
                novoDocumento.file.name
                }}</strong>
              <span *ngIf="!novoDocumento.file">Clique para seleccionar ficheiro &nbsp;·&nbsp; máx. 20 MB</span>
              <span *ngIf="novoDocumento.file" class="upload-replace">Clique para substituir</span>
            </div>
            <div class="sp-fg" style="margin-top: 14px">
              <label>Descrição / Nome do Documento</label>
              <input pInputText [(ngModel)]="novoDocumento.designacao"
                placeholder="Ex: Licença de Porte, Apólice 2026..." class="w-full" />
            </div>
            <div class="ip-actions" style="margin-top: 14px">
              <button type="button" class="btn-secondary sm" (click)="cancelarDocumento()">
                <i class="ri-close-line"></i> Cancelar
              </button>
              <p-button type="button" label="Fazer Upload" icon="pi pi-upload" size="small" [loading]="savingDocumento"
                [disabled]="!novoDocumento.file" (onClick)="salvarDocumento()" />
            </div>
          </div>
        </div>

        <!-- Documents list -->
        <div class="docs-list">
          <div class="doc-item" *ngFor="let d of documentos">
            <div class="doc-icon" [ngClass]="d.cor">
              <i [class]="d.icone"></i>
            </div>
            <div class="doc-info">
              <span class="doc-nome">{{ d.nome }}</span>
              <span class="doc-meta">{{ formatDate(d.data) }}</span>
            </div>
            <div class="doc-actions">
              <button class="btn-icon" pTooltip="Transferir" tooltipPosition="left"
                (click)="downloadDocumento(d.urlFicheiro, d.nome)" [disabled]="!d.urlFicheiro">
                <i class="ri-download-line"></i>
              </button>
              <div class="kebab-menu" [class.open]="openMenuId === 'd' + d.id" (click)="$event.stopPropagation()">
                <button class="btn-icon kebab-trigger" (click)="toggleMenu('d' + d.id, $event)" pTooltip="Acções"
                  tooltipPosition="top">
                  <i class="ri-more-2-fill"></i>
                </button>
                <div class="kebab-dropdown" *ngIf="openMenuId === 'd' + d.id">
                  <button class="kd-item danger" (click)="eliminarDocumento(d); openMenuId = null" [disabled]="!d.id">
                    <i class="ri-delete-bin-line"></i> Eliminar
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="docs-empty" *ngIf="!documentos.length">
            <i class="ri-folder-open-line"></i>
            <span>Nenhum documento registado</span>
          </div>
        </div>
      </p-tabpanel>
    </p-tabs>
  </ng-container>
</div>
